import { inject, Injectable } from '@angular/core';
import { AppflowChannel } from 'src/environments/appflow-channel';

import { Capacitor } from '@capacitor/core';
import { SessionTelemetry } from './auth/session/session-telemetry';
import { Logger } from './common/logging/logger';
import { DataRemovalRegistryService } from './shared/services/data-removal-registry.service';
import { ErpTaskStatusService } from './shared/services/erp-task/erp-task-status.service';
import { NetworkInfoService } from './shared/services/network/network-info.service';
import { PatientAppService } from './shared/services/patient-app/patient-app.service';
import { PushService } from './shared/services/push/push.service';

@Injectable()
export class AppInitService {
  private readonly _patientAppService: PatientAppService;

  constructor(
    logger: Logger,
    // constructed here so Sentry carries the session tags from the first event on
    _sessionTelemetry: SessionTelemetry,
    private _dataRemovalRegistryService: DataRemovalRegistryService,
    private _erpTaskStatusService: ErpTaskStatusService,
    private readonly _pushService: PushService,
    private readonly _networkInformationService: NetworkInfoService,
    private readonly _appflowChannel: AppflowChannel
  ) {
    window.logger = logger;
    if (!Capacitor.isNativePlatform()) {
      // PatientAppService is only needed for the agent chat.
      // On native platforms there is no agent chat.
      // This code is only needed to prevent RxDB initialization on native platform
      // because RxDB is injected in PatientAppService constructor.
      this._patientAppService = inject(PatientAppService);
    }
  }

  public init(): void {
    this._dataRemovalRegistryService.remove();
    this._erpTaskStatusService.init();
    if (!Capacitor.isNativePlatform()) {
      // On native platforms there is no agent chat
      // PatientAppService is only needed to enable Video Chat for patients
      // and depends on chat channels from RxDB
      this._patientAppService
        .init()
        .catch(error => window.logger.error('[AppInitService] patientAppService init failed', error));
    }
    this._pushService.init();
    this._networkInformationService
      .init()
      .catch(error => window.logger.error('[AppInitService] networkInformationService init failed', error));
    this._appflowChannel
      .init()
      .catch(error => window.logger.error('[AppInitService] appflowChannel init failed', error));
  }
}
